import React, { useRef } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { waLink, trackLead } from '../lib/whatsapp';
import { IMAGES, events, quoteMessage } from '../data/site';
import { useGSAP, gsap, MOTION_OK, revealOnScroll } from '../lib/gsap';
import { cn } from '../lib/utils';

// Bento: 4 eventos, 4 células. Cada célula já leva o tipo de evento para a
// mensagem do WhatsApp, então a escolha do visitante qualifica o pedido.
const layout = {
  casamento: 'md:col-span-4 md:row-span-2 bg-raised',
  aniversario: 'md:col-span-2',
  flashback: 'md:col-span-2',
  corporativo: 'md:col-span-6',
};

const EventTile = ({ event }) => {
  const image = event.image && IMAGES[event.image];

  return (
    <a
      href={waLink(quoteMessage(event.message))}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackLead(`event_${event.id}`)}
      data-reveal
      data-testid={`event-${event.id}`}
      className={cn(
        'group relative isolate flex min-h-[220px] flex-col justify-end overflow-hidden rounded-2xl p-6 md:p-8',
        image ? 'text-white' : '',
        layout[event.id]
      )}
    >
      {image && (
        <>
          <img src={image.src} alt="" loading="lazy" className="absolute inset-0 -z-20 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 -z-10 bg-gradient-to-t from-black/85 via-black/45 to-black/10" />
        </>
      )}
      <ArrowUpRight
        size={28}
        strokeWidth={1.75}
        aria-hidden="true"
        className="absolute right-6 top-6 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
      />
      <h3 className={cn('font-display font-bold tracking-tight', event.id === 'casamento' ? 'text-4xl md:text-6xl' : 'text-2xl md:text-3xl')}>
        {event.title}
      </h3>
      <p className={cn('mt-2 max-w-[42ch]', image ? 'text-white/80' : 'opacity-80', event.id === 'casamento' && 'md:text-lg')}>{event.text}</p>
      <span className="sr-only">Pedir orçamento pelo WhatsApp</span>
    </a>
  );
};

const Events = () => {
  const scope = useRef(null);

  useGSAP(() => gsap.matchMedia().add(MOTION_OK, () => revealOnScroll()), { scope });

  return (
    <section id="eventos" ref={scope} data-testid="events-section" className="px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 max-w-2xl md:mb-14" data-reveal>
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.14em] text-soft">Eventos</p>
          <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tight md:text-5xl">Cada festa pede uma pista diferente.</h2>
          <p className="mt-4 text-lg text-soft">Escolha o tipo do seu evento e peça o orçamento direto no WhatsApp.</p>
        </div>

        <div className="grid auto-rows-[minmax(220px,auto)] grid-cols-1 gap-4 md:grid-cols-6">
          {events.map((event) => (
            <EventTile key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Events;
